import { useEffect } from "react"
import { Button, Grid, Typography, useMediaQuery, useTheme } from "@mui/material"
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import { ISettingsItem, useSettings } from "../../../Settings"
import { useTranslation } from "../../../i18n"
import { ReactComponent as ChipMascot } from '../../../assets/icons/chipMascot.svg'
import { ReactComponent as ContelMascot } from '../../../assets/icons/contelMascot.svg'
import { useForm } from "../../../Form"

export default function InviteCard({ name, variables }: ISettingsItem) {
  const { currentFields: { isVoucherValid, voucherName } } = useForm()
  const { pageTitle } = useSettings()
  const { t } = useTranslation()
  const { text = [t.page1.invite.inviteFrom, t.page1.invite.toBePartOf, t.page1.invite.configureYourPlan] } = variables || {}
  const theme = useTheme()
  const isBelowMd = useMediaQuery(theme.breakpoints.down('md'))
  const cardText = `${text[0]} <span>${voucherName}</span> ${text[1]} <span>${pageTitle}.</span>`
  const el = document.getElementById('content-right-invite-card')

  useEffect(() => {
    if (el) {
      el.style.display = isVoucherValid ? 'flex' : 'none'
    }
  }, [el, isVoucherValid])

  const scrollToSelectPlan = () => {
    if (!isBelowMd) return

    const selectPlanElement = document.getElementsByClassName('choose-plan-text')
    if (selectPlanElement) {
      const offset = 30
      const elementPosition = selectPlanElement[0].getBoundingClientRect().top + window.scrollY
      window.scrollTo({
        top: elementPosition - offset,
        behavior: 'smooth',
      })
    }
  }

  return (
    <Grid item className={name ? `${name} invite-card` : "invite-card"} xs={12}
      sx={{
        display: isVoucherValid ? 'flex' : 'none',
        alignItems: 'center',
        justifyContent: 'space-between',
        p: { xs: '5px 25px', md: '2px 20px', lg: '4px 20px', xl: '5px 25px' },
        borderRadius: '19px',
        marginBottom: { xs: '25px', md: '2px', lg: '5px' },
        gap: { xs: '5px', md: '10px' },
      }}
    >
      <Grid sx={{ display: 'flex', flexDirection: 'column', gap: { xs: '12px', md: '2px', lg: '5px', xl: '10px' } }}>
        <Typography
          className="inviteCardTitle"
          variant="h3"
          sx={{
            fontSize: { xs: '15px', md: '8px', lg: '12px', xl: '14px' },
            maxWidth: { xs: '255px', lg: '260px' },
          }}
          dangerouslySetInnerHTML={{ __html: cardText }}
        />
        <Button
          className="inviteCardBtn"
          endIcon={<KeyboardArrowDownIcon />}
          onClick={scrollToSelectPlan}
          sx={{
            justifyContent: 'flex-start',
            gap: { xs: '10px', md: '0px' },
            p: 0,
            '&:hover': {
              cursor: isBelowMd ? 'pointer' : 'auto'
            }
          }}
        >
          <Typography
            variant="body2"
            dangerouslySetInnerHTML={{ __html: text[2] }}
            sx={{ fontSize: { xs: '11px', md: '7px', lg: '10px', xl: '11px' } }}
          />
        </Button>
      </Grid>
      <Grid
        sx={{ display: 'flex', 'svg': {
          height: { xs: '12vh', md: '10vh' },
          width: 'auto',
          'path': { fill: '' },
          'rect': { fill: '' },
          'ellipse': { fill: '' }
        }}}
      >
        {pageTitle === 'Contel' ? <ContelMascot /> : <ChipMascot />}
      </Grid>
    </Grid>
  )
}